import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ProfileImage from "../../assets/images/profile-image.png";

import Tiktokicon from "../../assets/images/social-icon/tiktok-icon.svg";
import Facebookicon from "../../assets/images/social-icon/facebook-icon.svg";
import Instagramicon from "../../assets/images/social-icon/instagram-icon.svg";
import Twittericon from "../../assets/images/social-icon/twitter-icon.svg";
import FifaIcon from "../../assets/images/game-rank-icon/fifa-ball-icon.svg";
import Callicon from "../../assets/images/game-rank-icon/call-of-ducty-icon.svg";
import ChessIcon from "../../assets/images/game-rank-icon/chess-icon.svg";
import ShareIcon from "../../assets/images/share_icon_main.svg";
import CommentedIcon from "../../assets/images/game-rank-icon/commented-icon.svg";
import CopyLinkIcon from "../../assets/images/media-share-icon/copy-link.svg";
import YouTubeLinkIcon from "../../assets/images/media-share-icon/youtube.svg";
import TwitchLinkIcon from "../../assets/images/media-share-icon/twich-icon.svg";
import InstagramLinkIcon from "../../assets/images/media-share-icon/instagram-icon.svg";
import KickLinkIcon from "../../assets/images/media-share-icon/kick-icon.svg";
import ThrophieImage from "../../assets/images/trofies-image.svg";
import GoldImage from "../../assets/images/gold-button-image.svg";
import SilverImage from "../../assets/images/silver-butto-image.svg";
import BrozeImage from "../../assets/images/bronze-button-image.svg";

import {
  Button,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Tooltip,
  Dropdown,
  Menu,
  Form,
  Divider,
} from "antd";
import Main from "../../components/layout/Main";
import TextArea from "antd/lib/input/TextArea";

import {
  CloseOutlined,
  EnvironmentOutlined,
  HeartFilled,
  PictureOutlined,
  SmileOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { Ellipsis, Heart, MessageCircle } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Severty, ShowToast } from "../../helper/toast";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import LocationPicker from "../../components/LocationPicker";
import moment from "moment";
import { isValidUrl } from "../../helper/functions";
import ShareModal from "../../components/ShareModal";
import { shareProfile } from "../../utils/share";
import UniversalShareModal from "../../components/UniversalShareModal";
const { Option } = Select;

function ProfileIndex() {
  const [profile, setProfile] = useState();
  const [trophies, setTrophies] = useState([]);
  const [commentInputPostId, setCommentInputPostId] = useState(false);
  const [comment, setComment] = useState("");
  const [fileError, setFileError] = useState(null);
  const [videoError, setVideoError] = useState(null);
  const [selectedPost, setSelectedPost] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [openModalName, setOpenModalName] = useState(null);
  const navigate = useNavigate();
  const userProfileData = JSON.parse(localStorage.getItem("userProfile"));
  const [locationModal, setLocationModal] = useState(false);
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markerInstance = useRef(null);
  const searchInputRef = useRef(null);
  const {
    getProfile,
    createPost,
    getPosts,
    createComment,
    likePost,
    deletePost,
    getTrophies,
    getActivityLog,
  } = useAuth();
  const [form] = Form.useForm();
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [value, setValue] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const [posts, setPosts] = useState([]);
  const fileInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const pickerRef = useRef(null);
  const emojiToggleRef = useRef(null);
  const mapToggleRef = useRef(null);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);
  const [previewVideos, setPreviewVideos] = useState([]);
  const [shareOpen, setShareOpen] = useState(false);
  const [activityLogs, setActivityLogs] = useState([]);
  const [tab, setTab] = useState("latest");

  const onLocationSelect = (location) => {
    form.setFieldsValue({
      streetAddress: location.address,
      state: location.state,
      country: location.country,
    });
  };

  const addEmoji = (emoji) => {
    setValue((prev) => prev + emoji.native);
    // setShowPicker(false);
  };

  // const handleImageChange = (e) => {
  //   const files = Array.from(e.target.files);
  //   setSelectedImages((prev) => [...prev, ...files]);
  //   // Optional: create preview URLs
  //   const previewUrls = files.map((file) => URL.createObjectURL(file));
  //   setPreviewImages((prev) => [...prev, ...previewUrls]);
  // };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    // Allowed file types
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

    const validFiles = [];
    const invalidFiles = [];

    files.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    });

    // If invalid files exist, show an error
    if (invalidFiles.length > 0) {
      setFileError(
        `❌ Invalid file type(s): ${invalidFiles.join(
          ", "
        )}\nOnly JPG, JPEG, and PNG files are allowed.`
      );
    }

    if (validFiles.length > 0) {
      setSelectedImages((prev) => [...prev, ...validFiles]);

      // Create local preview URLs for valid images
      const previewUrls = validFiles.map((file) => URL.createObjectURL(file));
      setPreviewImages((prev) => [...prev, ...previewUrls]);
    }

    // Reset file input so same file can be reselected if needed
    e.target.value = "";
  };

  useEffect(() => {
    if (locationModal && mapRef.current) {
      // Initialize Map
      mapInstance.current = new window.google.maps.Map(mapRef.current, {
        center: { lat: 25.2048, lng: 55.2708 },
        zoom: 10,
      });

      // Autocomplete Search
      const autocomplete = new window.google.maps.places.Autocomplete(
        searchInputRef.current,
        { types: ["geocode"] }
      );

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (!place.geometry) return;

        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        // Set Marker
        if (markerInstance.current) markerInstance.current.setMap(null);
        markerInstance.current = new window.google.maps.Marker({
          map: mapInstance.current,
          position: { lat, lng },
        });

        // Move Map
        mapInstance.current.setCenter({ lat, lng });

        // Send to parent
        onLocationSelect({
          lat,
          lng,
          address: place.formatted_address,
        });
      });

      // Map Click → Set Location
      mapInstance.current.addListener("click", (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();

        if (markerInstance.current) markerInstance.current.setMap(null);
        markerInstance.current = new window.google.maps.Marker({
          map: mapInstance.current,
          position: { lat, lng },
        });

        onLocationSelect({ lat, lng });
      });
    }
  }, [locationModal]);

  // const handleVideoChange = (e) => {
  //   const files = Array.from(e.target.files);
  //   setSelectedVideos((prev) => [...prev, ...files]);
  //   const previewUrls = files.map((file) => URL.createObjectURL(file));
  //   setPreviewVideos((prev) => [...prev, ...previewUrls]);
  // };

  const handleVideoChange = (e) => {
    const files = Array.from(e.target.files);

    // ✅ Allowed video/audio formats
    const allowedTypes = ["video/mp4", "audio/mpeg"]; // 'audio/mpeg' = MP3

    const validFiles = [];
    const invalidFiles = [];

    files.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    });

    // ❌ Show error if invalid files selected
    if (invalidFiles.length > 0) {
      setVideoError(
        `Invalid file(s): ${invalidFiles.join(
          ", "
        )}\nOnly MP4 and MP3 files are allowed.`
      );
    }

    // ✅ Only update state with valid files
    if (validFiles.length > 0) {
      setSelectedVideos((prev) => [...prev, ...validFiles]);
      const previewUrls = validFiles.map((file) => URL.createObjectURL(file));
      setPreviewVideos((prev) => [...prev, ...previewUrls]);
    }

    // Reset input so user can reselect same file again if needed
    e.target.value = "";
  };

  const [locationValue, locationSetValue] = useState({
    open: false,
    streetAddress: "",
    state: "",
    country: "",
  });

  const fetchProfile = async () => {
    try {
      const response = await getProfile();
      if (response.status === 200) setProfile(response.data);
      const result = await getPosts();
      if (result.status === 200) setPosts(result.data.data);
      const trohpiesResponse = await getTrophies(userProfileData?._id);
      if (trohpiesResponse.status === 200) {
        setTrophies(trohpiesResponse?.data?.data?.data);
      }
    } catch (error) {
      console.log("Error fetching profile:", error);
    }
  };

  const fetchActivityLogs = async () => {
    try {
      const activityResponse = await getActivityLog({
        userId: userProfileData._id,
        type: tab,
      });
      if (activityResponse.status === 200) {
        setActivityLogs(activityResponse?.data?.data?.data);
      }
    } catch (error) {
      console.log("Error fetching profile:", error);
    }
  };

  const handleLikePost = async (postId) => {
    try {
      const response = await likePost(postId);
      if (response.status === 200) {
        fetchProfile();
      }
    } catch (error) {
      console.log("error in handle like post -->", error);
      ShowToast(error.message, Severty.ERROR);
    }
  };

  const handleCommentPost = async (postId, content) => {
    try {
      const response = await createComment(postId, content);
      if (response.status === 200) {
        fetchProfile();
        setCommentInputPostId(false);
        setComment("");
      }
    } catch (error) {
      console.log("error in handle comment post -->", error);
      ShowToast(error.message, Severty.ERROR);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !value?.trim() &&
      selectedImages.length === 0 &&
      selectedVideos.length === 0
    ) {
      ShowToast("Please write something or add media", Severty.ERROR);
      return;
    }

    const formData = new FormData();
    formData.append("body", value);
    formData.append("location", locationValue?.streetAddress || "");
    formData.append("isPrivate", isPrivate);
    selectedImages.forEach((file, idx) => {
      formData.append("mediaFiles", file);
    });
    selectedVideos.forEach((file, idx) => {
      formData.append("mediaFiles", file);
    });
    const response = await createPost(formData);
    if (response.status === 200 || response.status === 201) {
      ShowToast(response.message, Severty.SUCCESS);
      // 🔹 Clear form after successful post
      setValue("");
      setSelectedImages([]);
      setSelectedVideos([]);
      setPreviewImages([]);
      setPreviewVideos([]);
      fetchProfile();
    }
  };

  const handleDeletePost = async (postId) => {
    try {
      const response = await deletePost(postId);
      if (response.status === 200) {
        ShowToast(response.message, Severty.SUCCESS);
        fetchProfile();
      }
      setDeleteModalOpen(false);
    } catch (error) {
      ShowToast(error.message, Severty.ERROR);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  // Detect click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target) &&
        emojiToggleRef.current &&
        !emojiToggleRef.current.contains(event.target)
      ) {
        setShowPicker(false);
      }
      if (
        mapRef.current &&
        !mapRef.current.contains(event.target) &&
        mapToggleRef.current &&
        !mapToggleRef.current.contains(event.target)
      ) {
        locationSetValue((prev) => ({ ...prev, open: false }));
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    fetchActivityLogs();
  }, [tab]);

  // --------- Go to the specifi post -----------
  useEffect(() => {
    if (window.location.hash) {
      const postId = window.location.hash.replace("#", "");

      // Wait for posts to load
      setTimeout(() => {
        const element = document.getElementById(postId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300);
    }
  }, [posts]);

  return (
    <>
      <Main>
        <div className="section-main">
          <section className="profile-section">
            <h1 className="sidebar-title">Profile</h1>
            <Row gutter={[16, 16]}>
              <Col span={24} md={12} lg={14} xl={16}>
                <div className="profile-box-main">
                  <div className="profile-top-card-main">
                    <div className="profile-top-card-left">
                      {/* Profile Picture & Stats */}
                      <div className="profile-header">
                        <div className="avatar-wrapper">
                          <img
                            src={
                              isValidUrl(profile?.profilePic)
                                ? profile?.profilePic
                                : ProfileImage
                            }
                            alt="avatar"
                          />
                        </div>
                        <div className="stats">
                          <div
                            className="stat-block follwers-stat-block"
                            onClick={() => navigate(`/connections`)}
                          >
                            <h6 className="count">{profile?.followersCount}</h6>
                            <span className="label">Followers</span>
                          </div>
                          <div
                            className="stat-block follwers-stat-block"
                            onClick={() =>
                              navigate(`/connections`, {
                                state: { data: "following" },
                              })
                            }
                          >
                            <h6 className="count">{profile?.followingCount}</h6>
                            <span className="label">Following</span>
                          </div>
                          <div className="stat-block">
                            <h6 className="count">{posts?.length}</h6>
                            <span className="label">Posts</span>
                          </div>
                        </div>
                      </div>

                      {/* Name and Handle */}
                      <div className="username">
                        <h6 className="name">
                          {profile?.name} <span>#{profile?.rankId}</span>
                        </h6>
                        <span className="handle">{profile?.username}</span>
                      </div>

                      {/* Location */}
                      <div className="profile-location">
                        <div>{profile?.location}</div>
                      </div>

                      {/* Action Buttons */}
                      <div className="profile-actions">
                        <Button
                          className="btn-fill-small"
                          onClick={() => navigate("/edit-profile")}
                        >
                          Edit Profile
                        </Button>
                        <Button
                          className="btn-fill-small"
                          onClick={() => setIsShareModalOpen(true)}
                        >
                          Share Profile
                        </Button>
                      </div>
                      {/* Social Links */}
                      <div className="profile-actions">
                        {profile?.xLink?.trim() !== "" && (
                          <Link to={profile?.xLink} className="btn-social">
                            <img src={Twittericon} alt="twitter" />
                          </Link>
                        )}
                        {profile?.instagramLink?.trim() !== "" && (
                          <Link
                            to={profile?.instagramLink}
                            className="btn-social"
                          >
                            <img src={Instagramicon} alt="instagram" />
                          </Link>
                        )}
                        {profile?.facebookLink?.trim() !== "" && (
                          <Link
                            to={profile?.facebookLink}
                            className="btn-social"
                          >
                            <img src={Facebookicon} alt="facebook" />
                          </Link>
                        )}
                        {profile?.tikTokLink?.trim() !== "" && (
                          <Link to={profile?.tikTokLink} className="btn-social">
                            <img src={Tiktokicon} alt="tiktok" />
                          </Link>
                        )}
                      </div>
                    </div>

                    {/* Right Side */}
                    <div className="profile-top-card-right">
                      <div className="profile-top-rankbox">
                        <div
                          className="profile-top-rankbox-inner"
                          style={{ cursor: "pointer" }}
                          onClick={() => setOpenModalName("trophiesModal")}
                        >
                          <h6>Trophies</h6>
                          <p>{trophies?.length || "N/A"}</p>
                        </div>
                        <div className="profile-top-rankbox-inner">
                          <h6>Rank</h6>
                          <p>{profile?.rank}</p>
                        </div>
                        <div className="profile-top-rankbox-inner">
                          <h6>Gender</h6>
                          <p>{profile?.gender}</p>
                        </div>
                      </div>

                      <div className="game-rank-list">
                        <div className="game-rank-list-header">
                          <h6>Game Ranks</h6>
                          <Link>View All</Link>
                        </div>

                        {/* Example Games */}
                        <div className="game-row">
                          <div className="game-info">
                            <img src={Callicon} alt="call of duty" />
                            <div>
                              <h6 className="game-title">Call of Duty</h6>
                              <span className="game-level">Master Level</span>
                            </div>
                          </div>
                          <h6 className="game-rank">#12</h6>
                        </div>

                        <div className="game-row">
                          <div className="game-info">
                            <img src={FifaIcon} alt="fifa 2025" />
                            <div>
                              <h6 className="game-title">FIFA 2025</h6>
                              <span className="game-level">Elite Division</span>
                            </div>
                          </div>
                          <h6 className="game-rank">#42</h6>
                        </div>

                        <div className="game-row">
                          <div className="game-info">
                            <img src={ChessIcon} alt="chess" />
                            <div>
                              <h6 className="game-title">Chess</h6>
                              <span className="game-level">Diamond League</span>
                            </div>
                          </div>
                          <h6 className="game-rank">#42</h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Post Composer */}
                  <div className="post-user sub-profile-main">
                    <img
                      src={profile?.profilePic || ProfileImage}
                      alt="Profile"
                    />
                    <div>
                      <h6 className="post-name">{profile?.name}</h6>
                      <Select
                        defaultValue="Public"
                        onChange={(value) => setIsPrivate(value)}
                        className="status-select"
                        dropdownClassName="status-select-dropdown"
                      >
                        <Option value={false}>Public</Option>
                        <Option value={true}>Private</Option>
                      </Select>
                    </div>
                  </div>

                  <div className="sub-profile-bottam">
                    <p className="composer-placeholder">What's on your mind?</p>
                    <form onSubmit={handleSubmit}>
                      <div className="textarea-post-comment">
                        <div className="post-input-wrapper">
                          <input
                            type="file"
                            accept="image/*"
                            multiple
                            ref={fileInputRef}
                            onChange={handleImageChange}
                            style={{ display: "none" }}
                          />
                          <input
                            type="file"
                            accept="video/*"
                            multiple
                            ref={videoInputRef}
                            onChange={handleVideoChange}
                            style={{ display: "none" }}
                          />

                          {/* Image Preview */}
                          <div
                            style={{
                              display: "flex",
                              gap: 10,
                              flexWrap: "wrap",
                            }}
                          >
                            {previewImages.map((url, idx) => (
                              <div key={idx} style={{ position: "relative" }}>
                                <span
                                  onClick={() => {
                                    // Remove File object and preview
                                    setSelectedImages((prev) =>
                                      prev.filter((_, i) => i !== idx)
                                    );
                                    setPreviewImages((prev) =>
                                      prev.filter((_, i) => i !== idx)
                                    );
                                  }}
                                  style={{
                                    position: "absolute",
                                    top: -8,
                                    right: -8,
                                    background: "rgba(0,0,0,0.6)",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: 20,
                                    height: 20,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    fontSize: 12,
                                    zIndex: 1,
                                  }}
                                >
                                  ×
                                </span>
                                <img
                                  src={url}
                                  alt={`preview-${idx}`}
                                  style={{
                                    width: "100%",
                                    maxWidth: "150px",
                                    minHeight: "100px",
                                    borderRadius: 8,
                                    marginBottom: 10,
                                  }}
                                />
                              </div>
                            ))}
                          </div>

                          {/* Video Preview */}
                          <div
                            style={{
                              display: "flex",
                              gap: 10,
                              flexWrap: "wrap",
                            }}
                          >
                            {previewVideos.map((url, idx) => (
                              <div key={idx} style={{ position: "relative" }}>
                                <span
                                  onClick={() => {
                                    // Remove both file and preview
                                    setSelectedVideos((prev) =>
                                      prev.filter((_, i) => i !== idx)
                                    );
                                    setPreviewVideos((prev) =>
                                      prev.filter((_, i) => i !== idx)
                                    );
                                  }}
                                  style={{
                                    position: "absolute",
                                    top: -8,
                                    right: -8,
                                    background: "rgba(0,0,0,0.6)",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: 20,
                                    height: 20,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    fontSize: 12,
                                    zIndex: 1,
                                  }}
                                >
                                  ×
                                </span>
                                <video
                                  src={url}
                                  controls
                                  style={{
                                    width: "100%",
                                    maxWidth: "150px",
                                    borderRadius: 8,
                                    marginBottom: 10,
                                  }}
                                />
                              </div>
                            ))}
                          </div>

                          <TextArea
                            placeholder="Add to your post"
                            rows={3}
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                          />
                        </div>

                        <div
                          className="post-actions"
                          style={{ position: "relative" }}
                        >
                          <Tooltip title="Upload Photo">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => fileInputRef.current.click()}
                            >
                              <PictureOutlined />
                            </span>
                          </Tooltip>
                          <Tooltip title="Upload MP4 Video">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => videoInputRef.current.click()}
                            >
                              <VideoCameraOutlined />
                            </span>
                          </Tooltip>
                          <Tooltip title="Location">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => setLocationModal(true)}
                            >
                              <EnvironmentOutlined />
                            </span>
                          </Tooltip>
                          <Modal
                            open={locationModal}
                            onCancel={() => setLocationModal(false)}
                            footer={null}
                            width={800}
                          >
                            <div
                              style={{ position: "relative", height: "500px" }}
                            >
                              {/* Search Bar */}
                              <input
                                ref={searchInputRef}
                                type="text"
                                placeholder="Search location..."
                                style={{
                                  width: "300px",
                                  padding: "10px",
                                  position: "absolute",
                                  top: "10px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  zIndex: 20,
                                  borderRadius: "8px",
                                  border: "1px solid #ccc",
                                }}
                              />

                              {/* Map Container */}
                              <div
                                ref={mapRef}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "10px",
                                  marginTop: "50px",
                                }}
                              ></div>
                            </div>
                          </Modal>

                          {locationValue?.open && (
                            <div className="map-area" ref={mapRef}>
                              <LocationPicker
                                onLocationSelect={(location) => {
                                  if (
                                    location &&
                                    typeof locationSetValue === "function"
                                  ) {
                                    locationSetValue((prev) => ({
                                      ...prev,
                                      streetAddress: location.address || "",
                                      state: location.state || "",
                                      country: location.country || "",
                                    }));
                                  } else {
                                    console.warn(
                                      "locationSetValue is not defined or location is invalid"
                                    );
                                  }
                                }}
                              />
                            </div>
                          )}

                          <Tooltip title="Emoji">
                            <span
                              ref={emojiToggleRef}
                              style={{ cursor: "pointer", fontSize: 20 }}
                              onClick={() => setShowPicker((prev) => !prev)}
                            >
                              <SmileOutlined />
                            </span>
                          </Tooltip>
                          {showPicker && (
                            <div
                              style={{
                                position: "absolute",
                                top: "40px",
                                right: 0,
                                zIndex: 9999,
                              }}
                              className="emoji-picker"
                              ref={pickerRef}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Picker data={data} onEmojiSelect={addEmoji} />
                            </div>
                          )}
                        </div>
                      </div>
                      {fileError && (
                        <p
                          className="profile-file-error"
                          style={{ color: "red" }}
                        >
                          {fileError}
                        </p>
                      )}
                      {videoError && (
                        <p
                          className="profile-file-error"
                          style={{ color: "red" }}
                        >
                          {videoError}
                        </p>
                      )}
                      <Button
                        className="fill-button-smal"
                        type="primary"
                        htmlType="submit"
                      >
                        Share Post
                      </Button>
                    </form>
                  </div>

                  {/* Feed Posts */}
                  <div className="feed-post_all">
                    {posts.map((post, index) => (
                      <div className="feed-post" key={index}>
                        <div className="post-header">
                          <div className="post-user">
                            <img
                              src={post?.profilePic || ProfileImage}
                              alt="john doe"
                            />
                            <div>
                              <h6 className="post-name">{post?.name}</h6>
                              <span className="post-date">
                                {moment(post?.updated_at).format("MMM Do YYYY")}
                              </span>
                            </div>
                          </div>
                          {/* <Button className="more-button">
                          <Ellipsis />
                        </Button> */}
                          <Dropdown
                            trigger={["click"]}
                            placement="bottomRight"
                            overlay={
                              <Menu
                                items={[
                                  {
                                    key: "delete",
                                    label: (
                                      <span
                                        style={{
                                          color: "red",
                                          fontWeight: 500,
                                        }}
                                        onClick={() => {
                                          setSelectedPost(post?._id);
                                          setDeleteModalOpen(true);
                                        }}
                                      >
                                        Delete Post
                                      </span>
                                    ),
                                  },
                                ]}
                                className="post-options-dropdown"
                              />
                            }
                          >
                            <Button
                              className="more-button"
                              style={{
                                background: "transparent",
                                border: "none",
                                padding: "0",
                                height: "auto",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Ellipsis size={22} color="#fff" />
                            </Button>
                          </Dropdown>
                        </div>
                        <div className="feed-images">
                          {post.mediaFiles.map((file, index) => {
                            const isImage =
                              /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(file);
                            const isVideo = /\.(mp4|mov|webm|ogg)$/i.test(file);

                            return (
                              <div key={index}>
                                {isImage && (
                                  <img
                                    src={file}
                                    alt="media"
                                    style={{
                                      height: "200px",
                                      objectFit: "cover",
                                    }}
                                  />
                                )}

                                {isVideo && (
                                  <video
                                    src={file}
                                    controls
                                    style={{
                                      height: "200px",
                                      objectFit: "cover",
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </div>
                        <div className="feed-text">{post?.body}</div>
                        {post?.allowComments && (
                          <div className="games-connections-input">
                            <img src={CommentedIcon} alt="activity2" />
                            {/* <Input className="connections-input" /> */}
                          </div>
                        )}
                        <div className="post-reactions">
                          <div className="reaction-group">
                            <div
                              className="reaction"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleLikePost(post?._id)}
                            >
                              {post?.isLiked ? (
                                <HeartFilled
                                  style={{ fontSize: 22, color: "red" }}
                                />
                              ) : (
                                <Heart />
                              )}
                              <span>{post?.totalLikes}</span>
                            </div>
                            <div
                              className="reaction"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                setCommentInputPostId((prev) =>
                                  prev === post?._id ? null : post?._id
                                )
                              }
                            >
                              <MessageCircle />
                              <span>{post?.totalComments}</span>
                            </div>
                          </div>
                          <img
                            onClick={() => setShareOpen(true)}
                            src={ShareIcon}
                            alt="share"
                            className="share-icon"
                          />
                        </div>
                        {commentInputPostId === post?._id && (
                          <div className="feed-text">
                            <TextArea
                              className="post-comment-textArea"
                              style={{
                                backgroundColor: "#251e3f",
                                borderRadius: "5px",
                              }}
                              onChange={(e) => setComment(e.target.value)}
                            />
                            <Button
                              className="Fill-button submit-button-mainjhjh"
                              onClick={() =>
                                handleCommentPost(post?._id, comment)
                              }
                            >
                              Submit
                            </Button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </Col>

              {/* Activity Log */}
              <Col span={24} md={12} lg={10} xl={8}>
                <div className="game-rank-list">
                  <div className="game-rank-list-header">
                    <h6>Activity Log</h6>
                    <Link>View All</Link>
                  </div>
                  <div className="activity-logs-tabs">
                    <div
                      className={tab === "latest" ? "activity-logs-tab" : ""}
                      onClick={() => setTab("latest")}
                    >
                      Latest
                    </div>
                    <div
                      className={tab === "private" ? "activity-logs-tab" : ""}
                      onClick={() => setTab("private")}
                    >
                      Private
                    </div>
                  </div>
                  <Divider className="divider" />
                  <div className="active-log-table">
                    <ul>
                      {activityLogs && activityLogs.length > 0 ? (
                        activityLogs?.map((activity, i) => (
                          <li key={i}>
                            <div className="active-log-leftbar">
                              <h6>{activity?.tournamentName}</h6>
                              <h5> {activity?.result}</h5>
                            </div>
                            <div className="active-log-rightbar">
                              <p>
                                {moment(activity?.date).format("DD MMM YYYY")}
                              </p>
                              <h5>
                                {activity?.trophy === "Gold"
                                  ? "🥇"
                                  : activity?.trophy === "Silver"
                                  ? "🥈"
                                  : "🥉"}{" "}
                                {activity?.trophy}
                              </h5>
                            </div>
                          </li>
                        ))
                      ) : (
                        <p>No activity logs found</p>
                      )}
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </div>
      </Main>

      {/* Share Modal */}
      <Modal
        width={400}
        title="Share Profile"
        open={isShareModalOpen}
        onOk={() => setIsShareModalOpen(false)}
        onCancel={() => setIsShareModalOpen(false)}
        footer={false}
        className="custom-modal"
      >
        <div className="share-button-list">
          <Link
            onClick={async () => {
              const url = `${window.location.origin}/profile/${profile?._id}`;
              await navigator.clipboard.writeText(url);
              ShowToast("Link copied!", Severty.SUCCESS);
            }}
            className="share-btn-modal"
          >
            <img src={CopyLinkIcon} alt="copy link" />
            <p>Copy Link</p>
          </Link>
          <Link to="https://www.youtube.com/" className="share-btn-modal">
            <img src={YouTubeLinkIcon} alt="youtube" />
            <p>YouTube</p>
          </Link>
          <Link to="https://www.twitch.tv/" className="share-btn-modal">
            <img src={TwitchLinkIcon} alt="twitch" />
            <p>Twitch</p>
          </Link>
          <Link to="https://www.instagram.com/" className="share-btn-modal">
            <img src={InstagramLinkIcon} alt="instagram" />
            <p>Instagram</p>
          </Link>
          <Link to="https://kick.com/" className="share-btn-modal">
            <img src={KickLinkIcon} alt="kick" />
            <p>Kick</p>
          </Link>
        </div>
      </Modal>

      {/* Delete Modal */}
      <Modal
        open={deleteModalOpen}
        onCancel={() => setDeleteModalOpen(false)}
        footer={null}
        centered
        width={380}
        className="delete-modal"
      >
        <div style={{ textAlign: "center", padding: "20px 10px" }}>
          <h3 style={{ color: "white", marginBottom: "8px" }}>
            Delete this post?
          </h3>
          <p style={{ color: "#aaa", fontSize: "14px", marginBottom: "24px" }}>
            This action cannot be undone.
          </p>
          <div
            style={{ display: "flex", justifyContent: "center", gap: "10px" }}
          >
            <button
              style={{
                background: "transparent",
                color: "#fff",
                border: "1px solid #555",
                borderRadius: "6px",
                padding: "8px 18px",
              }}
              onClick={() => setDeleteModalOpen(false)}
            >
              Cancel
            </button>
            <button
              style={{
                background: "#ff4d4f",
                color: "white",
                border: "none",
                borderRadius: "6px",
                padding: "8px 18px",
              }}
              onClick={() => handleDeletePost(selectedPost)}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>

      {/* <ShareModal
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        url={`${window.location.origin}/profile/${profile?._id}`}
      /> */}

      <UniversalShareModal
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        url={window.location.href}
      />
      <Modal
        open={openModalName === "trophiesModal"}
        className="new-thropies-modal custome_mail_modal "
        footer={null}
        closable={false}
      >
        <div className="thropies-modal-header">
          <h4>Trophies</h4>

          <span
            className="close-btn120"
            style={{ cursor: "pointer" }}
            onClick={() => setOpenModalName(null)}
          >
            <CloseOutlined />
          </span>
        </div>

        <div className="panel game-ranks">
          {trophies &&
            trophies.map((trophie, index) => {
              return (
                <div className="game-row">
                  <div className="game-info">
                    <img src={ThrophieImage} alt="call of duty" />
                    <div>
                      <h6 className="game-title">
                        {trophie?.tournamentName?.toUpperCase()}
                      </h6>
                      <span className="game-level">
                        {trophie?.participantType}
                      </span>
                    </div>
                  </div>
                  <h6 className="game-rank game-rank__new">
                    <img src={GoldImage} alt="call of duty" /> {trophie?.trophy}
                  </h6>
                </div>
              );
            })}

          {/* <div className="game-row">
            <div className="game-info">
              <img src={ThrophieImage} alt="fifa 2025" />
              <div>
                <h6 className="game-title">FIFA 2025</h6>
                <span className="game-level">Elite Division</span>
              </div>
            </div>
            <h6 className="game-rank game-rank__new">
              <img src={SilverImage} alt="call of duty" />
              silver
            </h6>
          </div>
          <div className="game-row">
            <div className="game-info">
              <img src={ThrophieImage} alt="fifa 2025" />
              <div>
                <h6 className="game-title">FIFA 2025</h6>
                <span className="game-level">Elite Division</span>
              </div>
            </div>
            <h6 className="game-rank game-rank__new">
              {" "}
              <img src={BrozeImage} alt="call of duty" />
              bronze
            </h6>
          </div> */}
        </div>
        <div></div>
      </Modal>
    </>
  );
}

export default ProfileIndex;
